import React from "react";

import { templates } from "@reactivated";

import { NotFound } from "../components/NotFound";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.NotFoundTemplate) => {
    return (
        <PageSkeleton title={props.title}>
            <NotFound />
        </PageSkeleton>
    );
};
